import React, { useRef, useState, useEffect } from "react";
import { AnnotationOverlay } from "./AnnotationOverlay";

export const MediaItem = ({ mediaItem }) => {
  const imgRef = useRef(null);
  const [dims, setDims] = useState({ w: 96, h: 96 });

  useEffect(() => {
    if (imgRef.current && imgRef.current.complete) {
      setDims({ w: imgRef.current.clientWidth, h: imgRef.current.clientHeight });
    }
  }, []);

  // Support both API field name (mediaurl) and webapp upload field name (url)
  const mediaUrl = mediaItem?.mediaurl || mediaItem?.url;
  if (!mediaItem || !mediaUrl) return null;

  const isImage =
    mediaItem.type?.startsWith("image/") ||
    /\.(jpg|jpeg|png|gif)$/i.test(mediaUrl);
  const isVideo =
    mediaItem.type?.startsWith("video/") ||
    /\.(mp4|webm|ogg)$/i.test(mediaUrl);

  // Only show annotation overlay when the image has NOT been flattened yet.
  // When original_mediaurl exists, the annotations are already baked into mediaurl.
  const isFlattened = !!mediaItem.original_mediaurl;
  const hasAnnotations =
    isImage && !isFlattened && mediaItem.annotations && mediaItem.annotations !== "null";

  const handleImgLoad = () => {
    if (imgRef.current) {
      setDims({ w: imgRef.current.clientWidth, h: imgRef.current.clientHeight });
    }
  };

  return (
    <div className="relative group w-24 h-24 border rounded overflow-hidden shadow-sm">
      {isImage ? (
        <>
          <img
            ref={imgRef}
            src={mediaUrl}
            alt={mediaItem.naam || mediaItem.medianaam || "Media"}
            className="w-full h-full object-cover"
            onLoad={handleImgLoad}
          />
          {hasAnnotations && (
            <AnnotationOverlay
              annotations={mediaItem.annotations}
              width={dims.w}
              height={dims.h}
            />
          )}
        </>
      ) : isVideo ? (
        <video
          src={mediaUrl}
          controls
          className="w-full h-full object-cover"
        >
          Your browser does not support the video tag.
        </video>
      ) : (
        <a
          href={mediaUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center w-full h-full bg-gray-100 text-gray-600 text-xs p-1 break-all"
          title={mediaItem.naam || mediaItem.medianaam || "Open media"}
        >
          {mediaItem.naam || mediaItem.medianaam || "Bestand"}
        </a>
      )}
    </div>
  );
};
